module.exports = __webpack_public_path__ + "media/images/site/152-01-d59a09e3477e802c6a7a77379e638ca6.svg";